import React from 'react';
import Hero from '../components/Hero';
import Pricing from '../components/Pricing';
import About from '../components/About';
import Contact from '../components/Contact';

function Home() {
  return (
    <>
      <Hero />
      <Pricing />
      <About />
      <Contact />
    </>
  );
}

export default Home;
